module.exports = __webpack_public_path__ + "guide-integration03.8db6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-integration03.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-integration03.svg
// module chunks = main